// extracted by mini-css-extract-plugin
export default {"animatedBox":"serviceInfo_animatedBox__fwOo+","infoText":"serviceInfo_infoText__iRmJN"};